import SCTranslations from '../../../components/simpleCrud/SCTranslations.class';
import { SimpleCrudController } from '../../../components/simpleCrud/simpleCrud.controller';
import Field, {
  FieldApparence,
  FieldValidation
} from '../../../components/simpleCrud/field.class';

interface Service {
  name: String;
  info: String;
  price: Number; // prezzo in euro
}

export default class ServicesController extends SimpleCrudController {
  model: Service = {
    name: '',
    info: '',
    price: 0
  };
  fields = [
    new Field('name', 'text'),
    new Field('info', 'text', {
      apparence: new FieldApparence({ fullwidth: true })
    }),
    new Field('price', 'number'),
    new Field('isIPL', 'checkbox', {
      validation: new FieldValidation({ required: false })
    }),
    new Field('isProskin', 'checkbox', {
      validation: new FieldValidation({ required: false })
    })
  ];
  errors = {};
  submitted = false;

  translations: SCTranslations = new SCTranslations({
    listTitle: 'LBL_SERVICES',
    // newTitle: 'LBL_NEW_ASSISTANT',
    listIsEmpty: 'LBL_NO_SERVICES_FOUND',
    newTitleNoData: 'LBL_FIRST_NEW_SERVICE'
  });

  /*@ngInject*/
  constructor(Service, $timeout) {
    super($timeout);
    this.service = Service;
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/services/services.controller.ts